class ProductItem extends HTMLElement {
  constructor() {
    super()
    console.log('Instanciamos un product-element')
    const swatches = this.querySelector('.product-item-swatches')
    const images = this.querySelector('.product-item-js__image')
    swatches.addEventListener(
      'mouseover',
      e => {
        const target = e.target
        if (!target.classList.contains('color-swatch')) return
        console.log(target, target.dataset)
        const active = images.querySelector('.active')
        if (active) active.classList.remove('active')

        const current = images.querySelector(
          `[data-variant="${target.dataset.variantId}"]`
        )
        if (current) current.classList.add('active')
      },
      true
    )
    swatches.addEventListener('mouseleave', e => {
      images.querySelector('.active').classList.remove('active')
      images.querySelector('img').classList.add('active')
    })
  }
}
customElements.define('product-item', ProductItem)
